export default __webpack_public_path__ + "static/media/baby-crying.1f7d66be.jpg";